// @flow

import qs from 'qs';
import Api from './ApiBase';

export const getListParams = (params: any) => qs.stringify({
  include: 'company,region,work_type,entry_level,category,logo_image_item',
  ...params
});

export const getThirdPartyListParams = (params: any) => qs.stringify({
  include: 'place',
  ...params
});

class JobsApi extends Api {
  serializerType = 'jobs';

  serializerOptions = {
    attributes: ['desc'],
    company: { ref: 'id' },
    logoImageItem: { ref: 'id' },
    region: { ref: 'id' },
    typeForAttribute: (type: string) => {
      switch (type) {
      case 'logoImageItem': return 'logo_image_item';
      default: return undefined;
      }
    }
  };

  fetch = async (params: {} = {}) => {
    const json = await this.request(`search_jobs?${getListParams(params)}`);
    const data = await this.deserialize(json);

    return { data, meta: json.meta };
  }

  fetchThirdParty = async (params: {} = {}) => {
    const json = await this.request(`search_third_party_jobs?${getThirdPartyListParams(params)}`);
    const data = await this.deserialize(json);

    return { data, meta: json.meta };
  }
}

export default new JobsApi();
